module.exports = __webpack_public_path__ + "img/borders6.d76f266b.png";